// Comprehensive Master Database of All 28 States & 8 Union Territories of India and their Districts
// Specially annotated with major jewellery corridors and commercial trade hubs

export const INDIA_STATES_AND_DISTRICTS = [
  {
    state: 'Andhra Pradesh',
    districts: [
      'Alluri Sitharama Raju',
      'Anakapalli',
      'Ananthapuramu (Anantapur)',
      'Annamayya',
      'Bapatla',
      'Chittoor',
      'Dr. B.R. Ambedkar Konaseema',
      'East Godavari (Rajahmundry)',
      'Eluru',
      'Guntur',
      'Kakinada',
      'Krishna (Machilipatnam)',
      'Kurnool',
      'Nandyal',
      'NTR (Vijayawada)',
      'Palnadu',
      'Parvathipuram Manyam',
      'Prakasam (Ongole)',
      'Sri Potti Sriramulu Nellore',
      'Sri Sathya Sai',
      'Srikakulam',
      'Tirupati',
      'Visakhapatnam',
      'Vizianagaram',
      'West Godavari (Bhimavaram)',
      'YSR Kadapa',
    ],
  },
  {
    state: 'Arunachal Pradesh',
    districts: [
      'Anjaw',
      'Changlang',
      'Dibang Valley',
      'East Kameng',
      'East Siang (Pasighat)',
      'Itanagar Capital Complex',
      'Kamle',
      'Kra Daadi',
      'Kurung Kumey',
      'Lepa Rada',
      'Lohit',
      'Longding',
      'Lower Dibang Valley',
      'Lower Siang',
      'Lower Subansiri',
      'Namsai',
      'Pakke Kessang',
      'Papum Pare',
      'Shi Yomi',
      'Siang',
      'Tawang',
      'Tirap',
      'Upper Siang',
      'Upper Subansiri',
      'West Kameng (Bomdila)',
      'West Siang (Aalo)',
    ],
  },
  {
    state: 'Assam',
    districts: [
      'Baksa',
      'Barpeta',
      'Biswanath',
      'Bongaigaon',
      'Cachar (Silchar)',
      'Charaideo',
      'Chirang',
      'Darrang (Mangaldai)',
      'Dhemaji',
      'Dhubri',
      'Dibrugarh',
      'Dima Hasao (Haflong)',
      'Goalpara',
      'Golaghat',
      'Hailakandi',
      'Hojai',
      'Jorhat',
      'Kamrup',
      'Kamrup Metropolitan (Guwahati)',
      'Karbi Anglong (Diphu)',
      'Karimganj',
      'Kokrajhar',
      'Lakhimpur',
      'Majuli',
      'Morigaon',
      'Nagaon',
      'Nalbari',
      'Sivasagar',
      'Sonitpur (Tezpur)',
      'South Salmara-Mankachar',
      'Tinsukia',
      'Udalguri',
      'West Karbi Anglong',
    ],
  },
  {
    state: 'Bihar',
    districts: [
      'Araria',
      'Arwal',
      'Aurangabad',
      'Banka',
      'Begusarai',
      'Bhagalpur',
      'Bhojpur (Arrah)',
      'Buxar',
      'Darbhanga',
      'East Champaran (Motihari)',
      'Gaya',
      'Gopalganj',
      'Jamui',
      'Jehanabad',
      'Kaimur (Bhabua)',
      'Katihar',
      'Khagaria',
      'Kishanganj',
      'Lakhisarai',
      'Madhepura',
      'Madhubani',
      'Munger',
      'Muzaffarpur',
      'Nalanda (Bihar Sharif)',
      'Nawada',
      'Patna',
      'Purnia',
      'Rohtas (Sasaram)',
      'Saharsa',
      'Samastipur',
      'Saran (Chapra)',
      'Sheikhpura',
      'Sheohar',
      'Sitamarhi',
      'Siwan',
      'Supaul',
      'Vaishali (Hajipur)',
      'West Champaran (Bettiah)',
    ],
  },
  {
    state: 'Chhattisgarh',
    districts: [
      'Balod',
      'Baloda Bazar-Bhatapara',
      'Balrampur-Ramanujganj',
      'Bastar (Jagdalpur)',
      'Bemetara',
      'Bijapur',
      'Bilaspur',
      'Dantewada (South Bastar)',
      'Dhamtari',
      'Durg (Bhilai)',
      'Gariaband',
      'Gaurela-Pendra-Marwahi',
      'Janjgir-Champa',
      'Jashpur',
      'Kabirdham (Kawardha)',
      'Kanker (North Bastar)',
      'Khairagarh-Chhuikhadan-Gandai',
      'Kondagaon',
      'Korba',
      'Koriya',
      'Mahasamund',
      'Manendragarh-Chirmiri-Bharatpur',
      'Mohla-Manpur-Ambagarh Chowki',
      'Mungeli',
      'Narayanpur',
      'Raigarh',
      'Raipur',
      'Rajnandgaon',
      'Sarangarh-Bilaigarh',
      'Sakti',
      'Sukma',
      'Surajpur',
      'Surguja (Ambikapur)',
    ],
  },
  {
    state: 'Goa',
    districts: [
      'North Goa (Panaji, Mapusa, Calangute)',
      'South Goa (Margao, Vasco da Gama, Ponda)',
    ],
  },
  {
    state: 'Gujarat',
    districts: [
      'Ahmedabad (Manek Chowk)',
      'Amreli',
      'Anand',
      'Aravalli (Modasa)',
      'Banaskantha (Palanpur)',
      'Bharuch',
      'Bhavnagar',
      'Botad',
      'Chhota Udaipur',
      'Dahod',
      'Dang (Ahwa)',
      'Devbhoomi Dwarka',
      'Gandhinagar',
      'Gir Somnath (Veraval)',
      'Jamnagar',
      'Junagadh',
      'Kheda (Nadiad)',
      'Kutch (Bhuj, Gandhidham)',
      'Mahisagar (Lunawada)',
      'Mehsana',
      'Morbi',
      'Narmada (Rajpipla)',
      'Navsari',
      'Panchmahal (Godhra)',
      'Patan',
      'Porbandar',
      'Rajkot (Soni Bazaar)',
      'Sabarkantha (Himmatnagar)',
      'Surat (Diamond & Bullion Hub)',
      'Surendranagar',
      'Tapi (Vyara)',
      'Vadodara',
      'Valsad',
    ],
  },
  {
    state: 'Haryana',
    districts: [
      'Ambala',
      'Bhiwani',
      'Charkhi Dadri',
      'Faridabad',
      'Fatehabad',
      'Gurugram (Gurgaon)',
      'Hisar',
      'Jhajjar (Bahadurgarh)',
      'Jind',
      'Kaithal',
      'Karnal',
      'Kurukshetra',
      'Mahendragarh (Narnaul)',
      'Nuh (Mewat)',
      'Palwal',
      'Panchkula',
      'Panipat',
      'Rewari',
      'Rohtak',
      'Sirsa',
      'Sonipat',
      'Yamunanagar',
    ],
  },
  {
    state: 'Himachal Pradesh',
    districts: [
      'Bilaspur',
      'Chamba',
      'Hamirpur',
      'Kangra (Dharamshala)',
      'Kinnaur (Reckong Peo)',
      'Kullu',
      'Lahaul and Spiti (Keylong)',
      'Mandi',
      'Shimla (Mall Road)',
      'Sirmaur (Nahan)',
      'Solan',
      'Una',
    ],
  },
  {
    state: 'Jharkhand',
    districts: [
      'Bokaro',
      'Chatra',
      'Deoghar',
      'Dhanbad',
      'Dumka',
      'East Singhbhum (Jamshedpur)',
      'Garhwa',
      'Giridih',
      'Godda',
      'Gumla',
      'Hazaribagh',
      'Jamtara',
      'Khunti',
      'Koderma',
      'Latehar',
      'Lohardaga',
      'Pakur',
      'Palamu (Medininagar)',
      'Ramgarh',
      'Ranchi',
      'Sahibganj',
      'Seraikela Kharsawan',
      'Simdega',
      'West Singhbhum (Chaibasa)',
    ],
  },
  {
    state: 'Karnataka',
    districts: [
      'Bagalkote',
      'Ballari (Bellary)',
      'Belagavi (Belgaum)',
      'Bengaluru Rural',
      'Bengaluru Urban (Commercial St / Chickpet)',
      'Bidar',
      'Chamarajanagar',
      'Chikkaballapura',
      'Chikkamagaluru',
      'Chitradurga',
      'Dakshina Kannada (Mangaluru)',
      'Davanagere',
      'Dharwad (Hubballi)',
      'Gadag',
      'Hassan',
      'Haveri',
      'Kalaburagi (Gulbarga)',
      'Kodagu (Madikeri)',
      'Kolar (KGF)',
      'Koppal',
      'Mandya',
      'Mysuru (Mysore)',
      'Raichur',
      'Ramanagara',
      'Shivamogga (Shimoga)',
      'Tumakuru (Tumkur)',
      'Udupi',
      'Uttara Kannada (Karwar)',
      'Vijayanagara (Hosapete)',
      'Vijayapura (Bijapur)',
      'Yadgir',
    ],
  },
  {
    state: 'Kerala',
    districts: [
      'Alappuzha (Alleppey)',
      'Ernakulam (Kochi / Broadway)',
      'Idukki (Painavu)',
      'Kannur',
      'Kasaragod',
      'Kollam',
      'Kottayam',
      'Kozhikode (Calicut)',
      'Malappuram',
      'Palakkad',
      'Pathanamthitta',
      'Thiruvananthapuram (Trivandrum)',
      'Thrissur (Gold Jewellery Capital of India)',
      'Wayanad (Kalpetta)',
    ],
  },
  {
    state: 'Madhya Pradesh',
    districts: [
      'Agar Malwa',
      'Alirajpur',
      'Anuppur',
      'Ashoknagar',
      'Balaghat',
      'Barwani',
      'Betul',
      'Bhind',
      'Bhopal',
      'Burhanpur',
      'Chhatarpur',
      'Chhindwara',
      'Damoh',
      'Datia',
      'Dewas',
      'Dhar',
      'Dindori',
      'Guna',
      'Gwalior (Sarafa Bazaar)',
      'Harda',
      'Hoshangabad (Narmadapuram)',
      'Indore (Sarafa Night Bazaar)',
      'Jabalpur',
      'Jhabua',
      'Katni (Murwara)',
      'Khandwa',
      'Khargone',
      'Maihar',
      'Mandla',
      'Mandsaur',
      'Mauganj',
      'Morena',
      'Narsinghpur',
      'Neemuch',
      'Niwari',
      'Pandhurna',
      'Panna (Diamond Mines)',
      'Raisen',
      'Rajgarh',
      'Ratlam (Gold Benchmark)',
      'Rewa',
      'Sagar',
      'Satna',
      'Sehore',
      'Seoni',
      'Shahdol',
      'Shajapur',
      'Sheopur',
      'Shivpuri',
      'Sidhi',
      'Singrauli',
      'Tikamgarh',
      'Ujjain',
      'Umaria',
      'Vidisha',
    ],
  },
  {
    state: 'Maharashtra',
    districts: [
      'Ahmednagar (Ahilyanagar)',
      'Akola',
      'Amravati',
      'Beed',
      'Bhandara',
      'Buldhana',
      'Chandrapur',
      'Chhatrapati Sambhajinagar (Aurangabad)',
      'Dhule',
      'Gadchiroli',
      'Gondia',
      'Hingoli',
      'Jalgaon (Golden City of Maharashtra)',
      'Jalna',
      'Kolhapur (Kolhapuri Saaj)',
      'Latur',
      'Mumbai City (Zaveri Bazaar Central)',
      'Mumbai Suburban (Bandra, Andheri, Borivali)',
      'Nagpur (Itwari Sarafa)',
      'Nanded',
      'Nandurbar',
      'Nashik (Saraf Bazaar)',
      'Dharashiv (Osmanabad)',
      'Palghar',
      'Parbhani',
      'Pune (Laxmi Road / Raviwar Peth)',
      'Raigad (Navi Mumbai)',
      'Ratnagiri',
      'Sangli',
      'Satara',
      'Sindhudurg',
      'Solapur',
      'Thane',
      'Wardha',
      'Washim',
      'Yavatmal',
    ],
  },
  {
    state: 'Manipur',
    districts: [
      'Bishnupur',
      'Chandel',
      'Churachandpur',
      'Imphal East',
      'Imphal West',
      'Jiribam',
      'Kakching',
      'Kamjong',
      'Kangpokpi',
      'Noney',
      'Pherzawl',
      'Senapati',
      'Tamenglong',
      'Tengnoupal',
      'Thoubal',
      'Ukhrul',
    ],
  },
  {
    state: 'Meghalaya',
    districts: [
      'East Garo Hills',
      'East Jaintia Hills',
      'East Khasi Hills (Shillong)',
      'Eastern West Khasi Hills',
      'North Garo Hills',
      'Ri-Bhoi',
      'South Garo Hills',
      'South West Garo Hills',
      'South West Khasi Hills',
      'West Garo Hills (Tura)',
      'West Jaintia Hills (Jowai)',
      'West Khasi Hills',
    ],
  },
  {
    state: 'Mizoram',
    districts: [
      'Aizawl',
      'Champhai',
      'Hnahthial',
      'Khawzawl',
      'Kolasib',
      'Lawngtlai',
      'Lunglei',
      'Mamit',
      'Saitual',
      'Serchhip',
      'Siaha',
    ],
  },
  {
    state: 'Nagaland',
    districts: [
      'Chumoukedima',
      'Dimapur',
      'Kiphire',
      'Kohima',
      'Longleng',
      'Mokokchung',
      'Mon',
      'Niuland',
      'Noklak',
      'Peren',
      'Phek',
      'Shamator',
      'Tseminyu',
      'Tuensang',
      'Wokha',
      'Zunheboto',
    ],
  },
  {
    state: 'Odisha',
    districts: [
      'Angul',
      'Balangir',
      'Balasore (Baleswar)',
      'Bargarh',
      'Bhadrak',
      'Boudh',
      'Cuttack (Silver Filigree City)',
      'Deogarh',
      'Dhenkanal',
      'Gajapati',
      'Ganjam (Berhampur)',
      'Jagatsinghpur',
      'Jajpur',
      'Jharsuguda',
      'Kalahandi',
      'Kandhamal',
      'Kendrapara',
      'Kendujhar (Keonjhar)',
      'Khordha (Bhubaneswar)',
      'Koraput',
      'Malkangiri',
      'Mayurbhanj (Baripada)',
      'Nabarangpur',
      'Nayagarh',
      'Nuapada',
      'Puri',
      'Rayagada',
      'Sambalpur',
      'Subarnapur (Sonepur)',
      'Sundargarh (Rourkela)',
    ],
  },
  {
    state: 'Punjab',
    districts: [
      'Amritsar (Guru Bazaar)',
      'Barnala',
      'Bathinda',
      'Faridkot',
      'Fatehgarh Sahib',
      'Fazilka (Abohar)',
      'Ferozepur',
      'Gurdaspur (Batala)',
      'Hoshiarpur',
      'Jalandhar (Sarafa Bazaar)',
      'Kapurthala',
      'Ludhiana (Sarafa Bazaar / Ghumar Mandi)',
      'Malerkotla',
      'Mansa',
      'Moga',
      'Pathankot',
      'Patiala',
      'Rupnagar (Ropar)',
      'Sahibzada Ajit Singh Nagar (Mohali)',
      'Sangrur',
      'Shahid Bhagat Singh Nagar (Nawanshahr)',
      'Sri Muktsar Sahib',
      'Tarn Taran',
    ],
  },
  {
    state: 'Rajasthan',
    districts: [
      'Ajmer',
      'Alwar',
      'Anupgarh',
      'Balotra',
      'Banswara',
      'Baran',
      'Barmer',
      'Beawar',
      'Bharatpur',
      'Bhilwara',
      'Bikaner',
      'Bundi',
      'Chittorgarh',
      'Churu',
      'Dausa',
      'Deeg',
      'Didwana-Kuchaman',
      'Dholpur',
      'Dudu',
      'Dungarpur',
      'Ganganagar (Sri Ganganagar)',
      'Gangapur City',
      'Hanumangarh',
      'Jaipur Central (Johari Bazaar)',
      'Jaipur Rural',
      'Jaisalmer',
      'Jalore',
      'Jhalawar',
      'Jhunjhunu',
      'Jodhpur (Sojati Gate)',
      'Karauli',
      'Kekri',
      'Khairthal-Tijara',
      'Kota',
      'Kotputli-Behror',
      'Nagaur',
      'Neem Ka Thana',
      'Pali',
      'Phalodi',
      'Pratapgarh',
      'Rajsamand (Nathdwara)',
      'Salumbar',
      'Sanchore',
      'Sawai Madhopur',
      'Shahpura',
      'Sikar',
      'Sirohi',
      'Tonk',
      'Udaipur (Bada Bazaar)',
    ],
  },
  {
    state: 'Sikkim',
    districts: [
      'Gangtok',
      'Gyalshing (West Sikkim)',
      'Mangan (North Sikkim)',
      'Namchi (South Sikkim)',
      'Pakyong',
      'Soreng',
    ],
  },
  {
    state: 'Tamil Nadu',
    districts: [
      'Ariyalur',
      'Chengalpattu',
      'Chennai (T. Nagar / Sowcarpet)',
      'Coimbatore (Cross Cut Road / Big Bazaar)',
      'Cuddalore',
      'Dharmapuri',
      'Dindigul',
      'Erode',
      'Kallakurichi',
      'Kanchipuram (Silk & Gold)',
      'Kanyakumari (Nagercoil)',
      'Karur',
      'Krishnagiri (Hosur)',
      'Madurai (South Masi St)',
      'Mayiladuthurai',
      'Nagapattinam',
      'Namakkal',
      'Nilgiris (Udhagamandalam / Ooty)',
      'Perambalur',
      'Pudukkottai',
      'Ramanathapuram',
      'Ranipet',
      'Salem (Bazaar Street)',
      'Sivaganga',
      'Tenkasi',
      'Thanjavur',
      'Theni',
      'Thoothukudi (Tuticorin)',
      'Tiruchirappalli (Trichy / NSB Road)',
      'Tirunelveli',
      'Tirupathur',
      'Tiruppur',
      'Tiruvallur',
      'Tiruvannamalai',
      'Tiruvarur',
      'Vellore',
      'Viluppuram',
      'Virudhunagar (Sivakasi)',
    ],
  },
  {
    state: 'Telangana',
    districts: [
      'Adilabad',
      'Bhadradri Kothagudem',
      'Hanumakonda',
      'Hyderabad (Pot Market / Charminar / Panjagutta)',
      'Jagtial',
      'Jangaon',
      'Jayashankar Bhupalpally',
      'Jogulamba Gadwal',
      'Kamareddy',
      'Karimnagar',
      'Khammam',
      'Kumuram Bheem Asifabad',
      'Mahabubabad',
      'Mahbubnagar',
      'Mancherial',
      'Medak',
      'Medchal-Malkajgiri',
      'Mulugu',
      'Nagarkurnool',
      'Nalgonda',
      'Narayanpet',
      'Nirmal',
      'Nizamabad',
      'Peddapalli (Ramagundam)',
      'Rajanna Sircilla',
      'Rangareddy',
      'Sangareddy',
      'Siddipet',
      'Suryapet',
      'Vikarabad',
      'Wanaparthy',
      'Warangal',
      'Yadadri Bhuvanagiri',
    ],
  },
  {
    state: 'Tripura',
    districts: [
      'Dhalai (Ambassa)',
      'Gomati (Udaipur)',
      'Khowai',
      'North Tripura (Dharmanagar)',
      'Sepahijala (Bishramganj)',
      'South Tripura (Belonia)',
      'Unakoti (Kailashahar)',
      'West Tripura (Agartala)',
    ],
  },
  {
    state: 'Uttar Pradesh',
    districts: [
      'Agra (Kinari Bazaar)',
      'Aligarh',
      'Ambedkar Nagar',
      'Amethi',
      'Amroha',
      'Auraiya',
      'Ayodhya (Faizabad)',
      'Azamgarh',
      'Baghpat',
      'Bahraich',
      'Ballia',
      'Balrampur',
      'Banda',
      'Barabanki',
      'Bareilly',
      'Basti',
      'Bhadohi (Sant Ravidas Nagar)',
      'Bijnor',
      'Budaun',
      'Bulandshahr',
      'Chandauli',
      'Chitrakoot',
      'Deoria',
      'Etah',
      'Etawah',
      'Farrukhabad',
      'Fatehpur',
      'Firozabad (Bangle & Glass Hub)',
      'Gautam Buddha Nagar (Noida / Greater Noida)',
      'Ghaziabad',
      'Ghazipur',
      'Gonda',
      'Gorakhpur (Golghar)',
      'Hamirpur',
      'Hapur',
      'Hardoi',
      'Hathras',
      'Jalaun (Orai)',
      'Jaunpur',
      'Jhansi',
      'Kannauj',
      'Kanpur Dehat',
      'Kanpur Nagar (Birhana Road Sarafa)',
      'Kasganj',
      'Kaushambi',
      'Kheri (Lakhimpur Kheri)',
      'Kushinagar',
      'Lalitpur',
      'Lucknow (Chowk / Aminabad)',
      'Maharajganj',
      'Mahoba',
      'Mainpuri',
      'Mathura',
      'Mau',
      'Meerut (Neel Gali Sarafa)',
      'Mirzapur',
      'Moradabad (Peetal Nagari)',
      'Muzaffarnagar',
      'Pilibhit',
      'Pratapgarh',
      'Prayagraj (Allahabad / Chowk)',
      'Raebareli',
      'Rampur',
      'Saharanpur',
      'Sambhal',
      'Sant Kabir Nagar',
      'Shahjahanpur',
      'Shamli',
      'Shravasti',
      'Siddharthnagar',
      'Sitapur',
      'Sonbhadra',
      'Sultanpur',
      'Unnao',
      'Varanasi (Thatheri Bazaar / Chowk)',
    ],
  },
  {
    state: 'Uttarakhand',
    districts: [
      'Almora',
      'Bageshwar',
      'Chamoli (Gopeshwar)',
      'Champawat',
      'Dehradun (Paltan Bazaar)',
      'Haridwar (Jwalapur)',
      'Nainital (Haldwani)',
      'Pauri Garhwal (Kotdwar)',
      'Pithoragarh',
      'Rudraprayag',
      'Tehri Garhwal (New Tehri)',
      'Udham Singh Nagar (Rudrapur / Kashipur)',
      'Uttarkashi',
    ],
  },
  {
    state: 'West Bengal',
    districts: [
      'Alipurduar',
      'Bankura',
      'Birbhum (Suri)',
      'Cooch Behar',
      'Dakshin Dinajpur (Balurghat)',
      'Darjeeling (Siliguri)',
      'Hooghly (Chinsurah)',
      'Howrah',
      'Jalpaiguri',
      'Jhargram',
      'Kalimpong',
      'Kolkata (Bowbazar Gold Hub / Burrabazar)',
      'Malda (English Bazar)',
      'Murshidabad (Berhampore)',
      'Nadia (Krishnanagar)',
      'North 24 Parganas (Barasat)',
      'Paschim Bardhaman (Asansol / Durgapur)',
      'Paschim Medinipur (Midnapore)',
      'Purba Bardhaman (Bardhaman)',
      'Purba Medinipur (Tamluk)',
      'Purulia',
      'South 24 Parganas (Alipore)',
      'Uttar Dinajpur (Raiganj)',
    ],
  },
  // Union Territories
  {
    state: 'Andaman and Nicobar Islands',
    districts: [
      'Nicobar (Car Nicobar)',
      'North and Middle Andaman (Mayabunder)',
      'South Andaman (Port Blair)',
    ],
  },
  {
    state: 'Chandigarh',
    districts: [
      'Chandigarh (Sector 17 / Sector 22 Sarafa)',
    ],
  },
  {
    state: 'Dadra and Nagar Haveli and Daman and Diu',
    districts: [
      'Dadra and Nagar Haveli (Silvassa)',
      'Daman',
      'Diu',
    ],
  },
  {
    state: 'Delhi (NCT)',
    districts: [
      'Central Delhi (Karol Bagh / Chandni Chowk / Dariba Kalan)',
      'East Delhi (Laxmi Nagar / Preet Vihar)',
      'New Delhi (Connaught Place / South Extension)',
      'North Delhi (Civil Lines / Sadar Bazaar)',
      'North East Delhi (Shahdara / Seelampur)',
      'North West Delhi (Pitampura / Rohini)',
      'Shahdara',
      'South Delhi (Greater Kailash / Lajpat Nagar)',
      'South East Delhi (Def Col / Kalkaji)',
      'South West Delhi (Dwarka / Vasant Kunj)',
      'West Delhi (Rajouri Garden / Janakpuri / Tilak Nagar)',
    ],
  },
  {
    state: 'Jammu and Kashmir',
    districts: [
      'Anantnag',
      'Bandipora',
      'Baramulla',
      'Budgam',
      'Doda',
      'Ganderbal',
      'Jammu (Hari Market / Raghunath Bazaar)',
      'Kathua',
      'Kishtwar',
      'Kulgam',
      'Kupwara',
      'Poonch',
      'Pulwama',
      'Rajouri',
      'Ramban',
      'Reasi',
      'Samba',
      'Shopian',
      'Srinagar (Lal Chowk / Hari Singh High St)',
      'Udhampur',
    ],
  },
  {
    state: 'Ladakh',
    districts: [
      'Kargil',
      'Leh (Main Bazaar)',
    ],
  },
  {
    state: 'Lakshadweep',
    districts: [
      'Lakshadweep (Kavaratti / Agatti / Andrott)',
    ],
  },
  {
    state: 'Puducherry',
    districts: [
      'Karaikal',
      'Mahe',
      'Puducherry (MG Road / Heritage Town)',
      'Yanam',
    ],
  },
];

// Helper functions for easy querying
export const getAllStateNames = () => {
  return INDIA_STATES_AND_DISTRICTS.map((item) => item.state);
};

export const getDistrictsByState = (stateName) => {
  if (!stateName) return [];
  const found = INDIA_STATES_AND_DISTRICTS.find(
    (item) => item.state.toLowerCase() === stateName.toLowerCase()
  );
  return found ? found.districts : [];
};
